export default "__VITE_PUBLIC_ASSET__adde159f__"